import { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', service: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">

          {/* Left */}
          <div>
            <span className="text-xs font-medium tracking-widest text-violet-400 uppercase">Contact</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-6">
              Let's build something together.
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Have a project in mind? Fill out the form and I'll get back to you within 24 hours.
            </p>

            <div className="space-y-5">
              {[
                { icon: '📩', label: 'Email', value: 'hello@codevolt.dev' },
                { icon: '📍', label: 'Based in', value: 'Costa Rica — Available worldwide' },
              ].map(({ icon, label, value }) => (
                <div key={label} className="flex items-center gap-4">
                  <span className="text-xl">{icon}</span>
                  <div>
                    <p className="text-xs text-gray-600 uppercase tracking-wide">{label}</p>
                    <p className="text-sm text-gray-300">{value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="text-xs text-gray-500 uppercase tracking-wide mb-2 block">Name</label>
                <input
                  type="text" name="name" value={form.name} onChange={handleChange} required
                  placeholder="John Doe"
                  className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-violet-500 transition-colors"
                />
              </div>
              <div>
                <label className="text-xs text-gray-500 uppercase tracking-wide mb-2 block">Email</label>
                <input
                  type="email" name="email" value={form.email} onChange={handleChange} required
                  placeholder="john@company.com"
                  className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-violet-500 transition-colors"
                />
              </div>
            </div>

            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wide mb-2 block">Service</label>
              <select
                name="service" value={form.service} onChange={handleChange} required
                className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-violet-500 transition-colors appearance-none"
                style={{ backgroundColor: '#141414' }}
              >
                <option value="" disabled>Select a service</option>
                <option value="web">Web Application</option>
                <option value="mobile">Mobile App</option>
                <option value="enterprise">Enterprise / Desktop</option>
                <option value="ai">AI Integration</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wide mb-2 block">Message</label>
              <textarea
                name="message" value={form.message} onChange={handleChange} required rows={5}
                placeholder="Tell me about your project..."
                className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-violet-500 transition-colors resize-none"
              />
            </div>

            <button
              type="submit" disabled={status === 'loading'}
              className="w-full bg-violet-600 hover:bg-violet-500 disabled:opacity-50 text-white font-medium py-3.5 rounded-lg transition-colors text-sm">
              {status === 'loading' ? 'Sending...' : 'Send Message'}
            </button>

            {status === 'success' && (
              <p className="text-green-400 text-sm text-center">Message sent! I'll get back to you soon.</p>
            )}
            {status === 'error' && (
              <p className="text-red-400 text-sm text-center">Something went wrong. Please try again.</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
